var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import HealthInsuranceCardAPI from './health-insurance-card-api';
import './health-insurance-card-style.css';
import { ReactComponent as PatientMoneySvg } from '../../assets/images/icons/patient-rectangle-money.svg';
import { ReactComponent as PlusSolidSvg } from '../../assets/images/icons/plus-rectangle.svg';
import moment from 'moment';
import { LanguageService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { LocaleTypes } from '../../constants/locale-types';
let HealthInsuranceCard = class HealthInsuranceCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        ...this.props
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        categoryDesc: string,
        categoryId: string,
        healthCardNumber: string,
        healthInsuranceDesc: string,
        healthInsuranceId: number,
        ivaCategory: string,
        onClick: eventListener,
        planDesc: string,
        planId: string,
        walletExpiryDate: string
    }; }
    isIVACategoryVisible() {
        const language = LanguageService.getCurrentLanguage();
        return language == LocaleTypes.ARGENTINA;
    }
    renderPrivateCard() {
        return (React.createElement("div", { className: 'health-insurance-button' },
            React.createElement("div", { className: 'icon-container' },
                React.createElement(PatientMoneySvg, null)),
            React.createElement("h4", { className: 'card-value' }, MessageService.translate('tws.label.private-insurance'))));
    }
    renderNewItemCard() {
        return (React.createElement("div", { className: 'health-insurance-button' },
            React.createElement("div", { className: 'icon-container' },
                React.createElement(PlusSolidSvg, null)),
            React.createElement("h4", { className: 'card-value' }, MessageService.translate('tws.card.add-other-insurance'))));
    }
    renderDefaultCard() {
        const { healthInsuranceDesc, categoryDesc, planDesc, walletExpiryDate, healthCardNumber, ivaCategory } = this.props;
        const walletExpiryDateFormatted = walletExpiryDate
            ? ModelService.format('date', moment.utc(walletExpiryDate).format('L'), { type: 'timestamp' })
            : walletExpiryDate;
        return (React.createElement(React.Fragment, null,
            React.createElement("h4", { className: 'card-title' }, healthInsuranceDesc ?? '-'),
            React.createElement("div", { className: "packer" },
                React.createElement("div", null,
                    React.createElement("div", { className: "row" },
                        React.createElement("span", { className: 'card-label' },
                            MessageService.translate('insurances.category'),
                            ":"),
                        React.createElement("span", { className: 'card-value' }, categoryDesc ?? '-')),
                    React.createElement("div", { className: "row" },
                        React.createElement("span", { className: 'card-label' },
                            MessageService.translate('insurances.plan'),
                            ":"),
                        React.createElement("span", { className: 'card-value' }, planDesc ?? '-'))),
                React.createElement("div", null,
                    React.createElement("div", { className: "row", hidden: !this.isIVACategoryVisible() },
                        React.createElement("span", { className: 'card-label' },
                            MessageService.translate('insurances.iva-category'),
                            ":"),
                        React.createElement("span", { className: 'card-value' }, ivaCategory ?? '-')))),
            React.createElement("hr", null),
            React.createElement("div", { className: "packer" },
                React.createElement("div", null,
                    React.createElement("span", { className: 'card-label' },
                        MessageService.translate('tws.insurances.final-validity'),
                        ":"),
                    React.createElement("span", { className: 'card-value' }, walletExpiryDateFormatted ?? '-')),
                React.createElement("div", null,
                    React.createElement("span", { className: 'card-label' },
                        MessageService.translate('tws.insurances.health-card'),
                        ":"),
                    React.createElement("span", { className: 'card-value' }, healthCardNumber ?? '-')))));
    }
    render() {
        const { isPrivate, isNewItemButton, cardId } = this.props;
        return (React.createElement(Card, { className: 'health-insurance-card-custom', onClick: () => this.onClick(), selectable: true, selectionType: SelectionType.NONE, uuid: generateUUID(), key: cardId, width: 4 },
            React.createElement("div", { className: `health-insurance-card-content ${isPrivate || isNewItemButton ? 'health-insurance-actions' : ''}` }, isPrivate
                ? this.renderPrivateCard()
                : React.createElement(React.Fragment, null, isNewItemButton ? this.renderNewItemCard() : this.renderDefaultCard()))));
    }
};
HealthInsuranceCard = __decorate([
    AwesomeComponent({ api: HealthInsuranceCardAPI, type: ComponentType.DATA_DISPLAY })
], HealthInsuranceCard);
export default HealthInsuranceCard;
//# sourceMappingURL=health-insurance-card.js.map